import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Divider, Grid2, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';

import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
// import ExportToExcel from './ExportToExcel';
// import ExportToPDF from './ExportToPDF';


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));

export default function ProcurementPopup({ title, value, status, onClose, onOpen }) {


    const theme = useTheme();
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);

     const dummyData = [
        {
            sr_number: 1,
            package: "Package A",
            description: "Item A description",
            specification: "Spec A",
            quantity: 10,
            plannedPrddate: "2025-07-01",
            plannedPoDate: "2025-07-10",
        },
        {
            sr_number: 2,
            package: "Package B",
            description: "Item B description",
            specification: "Spec B",
            quantity: 5,
            plannedPrddate: "2025-07-05",
            plannedPoDate: "2025-07-15",
        },
    ];

   
   

    // Export complete data in PDF / Excel
    // const searchparamsexport = {
    //     ...searchparams,
    //     page: 1,
    //     pageSize: 1000,
    // } 

    // const { data: openCloseDataExport = [], error: openCloseExportError, isLoading: isOpenCloseExportLoading } = useGetAllRiskOpenCloseQuery(
    // searchparamsexport);
    // Export complete data in PDF / Excel

    const columns = [
        {
            name: "Sr No.",
            field: "sr_number",
        },
        {
            name: "Package",
            field: "package",
        },
        {
            name: "Item Description",
            field: "description",
        },
        {
            name: "Specification",
            field: "specification",
        },
        {
            name: "Quantity",
            field: "quantity",
        },
        {
            name: "Planned PR Date",
            field: "plannedPrddate",
            renderer(params) {
                return (
                    <>
                        {params?.plannedPrddate
                            ? moment(params.plannedPrddate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
            //renderExport: (row) => new Date(row.createdAt).toLocaleDateString(),
            // renderExport: (params) => moment(params.plannedPrddate).format("DD/MM/YYYY"),
        },
        {
            name: "Planned PO Date",
            field: "plannedPrDate",
            renderer(params) {
                return (
                    <>
                        {params?.plannedPoDate
                            ? moment(params.plannedP0Date).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
            //renderExport: (row) => new Date(row.createdAt).toLocaleDateString(),
            // renderExport: (params) => moment(params.createddate).format("DD/MM/YYYY"),
        },
        
    ]
    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={12}>
                                
                                {/* <ExportToExcel data={openCloseDataExport?.data} columns={columns} fileName="exportexcel_table" />
                                
                                <ExportToPDF data={openCloseDataExport?.data} columns={columns} fileName="exportpdf_table" /> */}

                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={dummyData} isLoading={false}/>

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={pageNumber}
                                        totalPages={1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>

                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}